import styled from 'styled-components';

const HeaderContainer = styled.div`
  height: 40px;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: visible;

  @supports (-webkit-line-clamp: 2) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`;

const ValueContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const UnitContainer = styled.div`
  text-align: center;
  margin-top: 8px;
`;

export { HeaderContainer, ValueContainer, UnitContainer };
